import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { BackIcon, CloseIcon, IconTimelineApproved, IconTimelineClock, IconTimelineMail, IconTimelineRecipient, IconTimelineRejected, SearchIcon } from '../../iconSet/IconSet';
import { EarlyWarningDataType, GroupDataRow, RecipientType, SelectedType, SubscribeListType, TimelineDataType, UserDataRow } from './EmailTypes';
import WarningWorkflowProcess from '../../warningWorkflowProcessComp/WarningWorkflowProcess';
import InputGroup from '../../inputComp/InputGroup';
import { APICallEarlyWarningRejectRequest, APICallGetAllWarningInfoRequest, APICallGetWarningsRequest, APICallWarningAcceptRequest, APIResponseEarlyWarningRejectTypes, APIResponseGetWarningRequestTypes, APIResponseGetWarningsTypes, APIWarningAcceptRequestTypes } from '../../../services/APIEarlyWarningService';
import GroupSelectTable from '../../warningWorkflowProcessComp/GroupSelectTable';
import UserSelectTable from '../../warningWorkflowProcessComp/UserSelectTable';
import AlertDialog from '../../popupComp/AlertDialog';
import LoadingScreen from '../../loadingScreenComp/LoadingScreen';
import WarningTable from './WarningTable';



/* const timeline: TimelineDataType[] = [
    {
        type: 'REQUESTED',
        userType: 'Officer NBRO',
        typeDes: 'Request for issuing Landslide Early Warning - New Version',
        bodyMessage: 'Request for declaring Landslide Early Warning - New Version warning(LSNEW1202) on 2025/02/28 07:15:20 Waiting ...',
        tag: [{label: 'email', value: 'pasindhu.bhathiya@gmail.com'}, {label: 'TP No', value: '+94778502467'}],
        date: '07:15:20'
    },
    {
        type: 'RECIPIENT',
        userType: '',
        typeDes: '',
        bodyMessage: '',
        tag: [{label: 'gayashan', value: 'gayashan@gmail.com'}, {label: 'withanage', value: '+94778502467'}],
        date: '2025/02/28 07:19:54'
    },
    {
        type: 'APPROVED',
        userType: 'Anuruddha NBRO',
        typeDes: 'Approved for Landslide Early Warning - New Version',
        bodyMessage: 'Approved for Landslide Early Warning - New Version warning(LSNEW1202) on 2025/02/28 07:19:54 Remarks :',
        tag: [{label: 'email', value: 'toanuruddha@gmail.com'}, {label: 'TP No', value: '+94778502467'}],
        date: '2025/02/28 07:19:54'
    },
    {
        type: 'REJECTED',
        userType: 'Anuruddha NBRO',
        typeDes: 'Approved for Landslide Early Warning - New Version',
        bodyMessage: 'Approved for Landslide Early Warning - New Version warning(LSNEW1202) on 2025/02/28 07:19:54 Remarks :',
        tag: [{label: 'email', value: 'toanuruddha@gmail.com'}, {label: 'TP No', value: '+94778502467'}],
        date: '2025/02/28 07:19:54'
    }
] */

const subscribeList: SubscribeListType[] = [
    {id: 'Sujeewa', name: 'Sujeewa', role: 'DMC Officer', area: 'Matara District', sms: true, whatsapp: false, tpNumber: '+94767047557'},
    {id: 'Sujeewa', name: 'Sujeewa', role: 'DMC Officer', area: 'Akuressa Divisional Secretarys Division', sms: true, whatsapp: true, tpNumber: '+94767047557'},
    {id: 'Thilina', name: 'Thilina', role: 'Irrigation Officer', area: 'Matara District', sms: true, whatsapp: true, tpNumber: '+94766673504'},
    {id: 'Thilina', name: 'Thilina', role: 'Irrigation Officer', area: 'Akuressa Divisional Secretarys Division', sms: true, whatsapp: true, tpNumber: '+94766673504'},
]

const tableDataGroup: GroupDataRow[] = [
    {groupid: 'id1', department: 'depart 1', groupname: 'group 1', select: false},
    {groupid: 'id2', department: 'depart 2', groupname: 'group 2', select: false},
    {groupid: 'id3', department: 'depart 3', groupname: 'group 3', select: false},
    {groupid: 'id4', department: 'depart 4', groupname: 'group 4', select: false},
    {groupid: 'id5', department: 'depart 5', groupname: 'group 5', select: false},
    {groupid: 'id6', department: 'depart 6', groupname: 'group 1', select: false},
    {groupid: 'id7', department: 'depart 7', groupname: 'group 2', select: false}
]

/* const tableDataUser: UserDataRow[] = [
    {id: 'id1', department: 'depart 1', username: 'user 1', sms: false, whatsapp: false, viber: false},
    {id: 'id2', department: 'depart 2', username: 'user 2', sms: false, whatsapp: false, viber: false},
    {id: 'id3', department: 'depart 3', username: 'user 3', sms: false, whatsapp: false, viber: false},
    {id: 'id4', department: 'depart 4', username: 'user 4', sms: false, whatsapp: false, viber: false},
    {id: 'id5', department: 'depart 5', username: 'user 5', sms: false, whatsapp: false, viber: false},
] */

/* const data: EarlyWarningDataType[] = [
    {
        id: 'id01', 
        type: 'REQUESTED', 
        title: 'Flood Warning for Western Province',
        username: 'gayashan',
        pageDate: 'Thu May 22 04:34:13 UTC 2025',
        timelineStartDate: '2025/02/28',
        timelineData: timeline,
        formData: {
            warningNumber: "EW/WP/2025/001",
            warningDate: "2025-05-22",
            requestName: "Western Province Disaster Management",
            requestsDepartment: "Regional Disaster Management Center",
            phone: "+94112345678",
            reqNumber: "DM/WP/REQ/042",
            requiredBefore: "2025-05-23T08:00:00",
            specialNote: "Urgent warning needed due to heavy monsoon rains",
            workflow: "Standard Emergency Protocol",
            fileName: ["flood_risk_map.jpg", "rainfall_data.pdf"],
            comments: "Need to issue warning for Colombo, Gampaha and Kalutara districts",
            messageEnglish: "Heavy rainfall expected in Western Province. Risk of flooding in low-lying areas.",
            messageSinhala: "බස්නාහිර පළාතේ තද වර්ෂාපතනයක් බලාපොරොත්තු වේ. පහත් ප්රදේශවල ගංවතුර ඇතිවීමේ අවදානමක් පවතී.",
            messageTamil: "மேற்கு மாகாணத்தில் கனமான மழைப்பொழிவு எதிர்பார்க்கப்படுகிறது. தாழ்நிலப் பகுதிகளில் வெள்ளம் ஏற்படும் அபாயம் உள்ளது.",
        },
        subscribeList: subscribeList,
        isSeen: false
    },
    {
        id: 'id02', 
        type: 'PENDING', 
        title: 'Drought Alert for Northern Province',
        username: 'gayashan',
        pageDate: 'Thu May 22 04:34:13 UTC 2025',
        timelineStartDate: '2025/02/28',
        timelineData: timeline,
        formData: {
            warningNumber: "EW/NP/2025/015",
            warningDate: "2025-05-21",
            requestName: "Northern Agriculture Department",
            requestsDepartment: "Department of Agriculture",
            phone: "+94212345678",
            reqNumber: "AG/NP/ALERT/202",
            requiredBefore: "2025-05-25T12:00:00",
            specialNote: "Prolonged drought conditions affecting crops",
            workflow: "Agricultural Advisory Protocol",
            fileName: ["drought_assessment.pdf", "crop_status.xlsx"],
            comments: "Need approval from Ministry of Agriculture before issuing",
            messageEnglish: "Severe drought conditions persist in Northern Province. Water conservation measures advised.",
            messageSinhala: "උතුරු පළාතේ දරුණු නියඟ තත්ත්වය පවතී. ජල සංරක්ෂණ පියවර ගැනීම රෙකමන්දු කෙරේ.",
            messageTamil: "வட மாகாணத்தில் கடுமையான வறட்சி நிலைமைகள் நீடிக்கின்றன. நீர் சேமிப்பு நடவடிக்கைகள் பரிந்துரைக்கப்படுகின்றன.",
        },
        subscribeList: subscribeList,
        isSeen: false
    },
    {
        id: 'id03', 
        type: 'APPROVED', 
        title: 'Landslide Warning for Central Province',
        username: 'gayashan',
        pageDate: 'Thu May 22 04:34:13 UTC 2025',
        timelineStartDate: '2025/02/28',
        timelineData: timeline,
        formData: {
            warningNumber: "EW/CP/2025/008",
            warningDate: "2025-05-20",
            requestName: "National Building Research Organization",
            requestsDepartment: "NBRO",
            phone: "+94117654321",
            reqNumber: "NBRO/ALERT/156",
            requiredBefore: "2025-05-20T18:00:00",
            specialNote: "High risk areas identified in Nuwara Eliya district",
            workflow: "Geological Hazard Protocol",
            fileName: ["landslide_risk_areas.pdf"],
            comments: "Approved by director as urgent warning",
            messageEnglish: "Landslide risk in Nuwara Eliya, Kandy and Badulla districts. Avoid slopes and unstable ground.",
            messageSinhala: "නුවරඑළිය, මහනුවර හා බදුල්ල දිස්ත්රික්කවල ගල්වැටීමේ අවදානමක් පවතී. බෑවුම් සහ අස්ථාවර භූමියෙන් වළකින්න.",
            messageTamil: "நுவரெலியா, கண்டி மற்றும் பதுளை மாவட்டங்களில் நிலச்சரிவு ஆபத்து. சரிவுகள் மற்றும் நிலையற்ற நிலப்பரப்பைத் தவிர்க்கவும்.",
        },
        subscribeList: subscribeList,
        isSeen: false
    },
    {
        id: 'id04', 
        type: 'PENDING', 
        title: 'Cyclone Alert for Eastern Coast',
        username: 'gayashan',
        pageDate: 'Thu May 22 04:34:13 UTC 2025',
        timelineStartDate: '2025/02/28',
        timelineData: timeline,
        formData: {
            warningNumber: "EW/EC/2025/003",
            warningDate: "2025-05-22",
            requestName: "Meteorological Department",
            requestsDepartment: "Department of Meteorology",
            phone: "+94119876543",
            reqNumber: "MET/CYCLONE/ALERT/042",
            requiredBefore: "2025-05-22T16:00:00",
            specialNote: "Cyclone BOB 05 forming in Bay of Bengal",
            workflow: "Tropical Cyclone Protocol",
            fileName: [],
            comments: "Waiting for confirmation from Indian Meteorological Department",
            messageEnglish: "Potential cyclone development observed. Fishermen advised not to venture into deep seas.",
            messageSinhala: "සුළං තත්ත්වයක් වර්ධනය වීම නිරීක්ෂණය කර ඇත. ගැඹුරු මුහුදට යාමෙන් මත්ස්යජීවීන් වලකින්න.",
            messageTamil: "சூறாவளி வளர்ச்சி காணப்படுகிறது. மீனவர்கள் ஆழ்கடலுக்குச் செல்லாமல் இருப்பது நல்லது.",
        },
        subscribeList: subscribeList,
        isSeen: false
    }
] */

/* const recipientNames: RecipientType[] = [
    {id: 'id1', name: 'name 1', departmentName: 'depart 1'},
    {id: 'id2', name: 'name 2', departmentName: 'depart 2'},
    {id: 'id3', name: 'name 3', departmentName: 'depart 3'},
    {id: 'id4', name: 'name 4', departmentName: 'depart 4'},
    {id: 'id5', name: 'name 5', departmentName: 'depart 5'},
    {id: 'id6', name: 'name 6', departmentName: 'depart 6'},
    {id: 'id7', name: 'name 7', departmentName: 'depart 7'},
    {id: 'id8', name: 'name 8', departmentName: 'depart 8'},
    {id: 'id9', name: 'name 9', departmentName: 'depart 9'},
    {id: 'id10', name: 'name 10', departmentName: 'depart 10'},
] */

const EarlyWarningMessages = () => {

    //const [messageData, setMessageData] = useState<EarlyWarningDataType[]>(data)

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [earlyWarningMessages, setEarlyWarningMessages] = useState<APIResponseGetWarningRequestTypes[]>([])

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertCallback, setAlertCallback] = useState<() => void | undefined>();

    const showAlertDialog = (title: string, description: string, callback?: () => void) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertCallback(() => callback); // wrap in function to preserve reference
    setAlertDialogState(true);
    };

    const [selected, setSelected] = useState<SelectedType>('PENDING')
    const [detailsSelected, setDetailsSelected] = useState<string>('')
    const [detailsSelectedData, setDetailsSelectedData] = useState<APIResponseGetWarningRequestTypes>()

    // Add recipient popup status
    const [addRecipientStatus, setAddRecipientStatus] = useState<boolean>(false)

    const allUsers = useRef<RecipientType[]>([]);

    const [filteredRecipient, setFilteredRecipient] = useState<RecipientType[]>([])

    // Selected recipient
    const [selectedRecipient, setSelectedRecipient] = useState<RecipientType[]>([])


    // Handle side menu button click
    const handleSideMenuButtonClick = (type: SelectedType) => {
        setSelected(type)
        setDetailsSelected('')
    }

    const dataCounter = (type: SelectedType): number => {
        if (type === 'ACCEPTED') {
            return earlyWarningMessages.filter(item => 
                item.status === 'ACCEPTED' || item.status === 'FINALIZE'
            ).length;
        }
        return earlyWarningMessages.filter(item => item.status === type).length;
    }

    const filterDataByType = (type: SelectedType): APIResponseGetWarningRequestTypes[] => {
        if (!Array.isArray(earlyWarningMessages)) return [];
        
        if (type === 'ACCEPTED') {
            return earlyWarningMessages.filter(item => 
                item.status === 'ACCEPTED' || item.status === 'FINALIZE'
            );
        }
        return earlyWarningMessages.filter(item => item.status === type);
    }

    const getDataById = (id: string): APIResponseGetWarningRequestTypes => {
        const foundData = earlyWarningMessages.filter(item => item.warningId === id)
        return foundData[0]
    }

    const getAllUsers = () => {
        const token = localStorage.getItem("access_token");
        fetch(BASE_URL + "/identity_manager/api/v1/getallusers", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                allUsers.current = data;
                setFilteredRecipient(data);
            })
            .catch((err) => console.error("Error fetching roles:", err));
    };

    useEffect(() => {
        getAllUsers();
    }, []);

    useEffect(() => {
        if (detailsSelected === '') {
            setDetailsSelectedData(undefined)
        } else {
            setDetailsSelectedData(getDataById(detailsSelected))
        }
    }, [detailsSelected, earlyWarningMessages])

    const handleClickMessage = (data: APIResponseGetWarningRequestTypes) => {
        setEarlyWarningMessages(prevState =>
            prevState.map(item =>
                item.warningId === data.warningId
                    ? { ...item, isSeen: true }
                    : item
            )
        )
        setDetailsSelected(data.warningId)
    }

    const findAnyUnSeenAvailable = (type: SelectedType): boolean => {
        const filterData = filterDataByType(type);
        return filterData?.some(item => item.isSeen === false) || false;
    }

    useEffect(() => {
        
        const fetchWarnings = async () => {
            try {
                setIsLoading(true)
                const response = await APICallGetAllWarningInfoRequest();
                setEarlyWarningMessages(response !== undefined ? response : [])
                setIsLoading(false)
            } catch (error) {
                console.error("Failed to fetch warnings:", error);
                setIsLoading(false)
            }
        }
        fetchWarnings()
        
    }, [])

    return (
        <div className={`container-wrapper`} style={{position: 'relative'}}>
			<span className={`title`}>early warning messages</span>
			
            <div className='email-wrapper'>
                <div className='email-header'>
                    {detailsSelected !== '' && (
                        <div className='left'>
                            <div className='back-button' onClick={(e) => setDetailsSelected('')}>
                                <BackIcon width='1.2rem' color='var(--color-text)'/>
                            </div>
                            <span className='header'>({detailsSelectedData?.warningId}) - {detailsSelectedData?.warningCatType}</span>
                        </div>
                    )}

                    <div className='right'></div>
                </div>
                <div className='email-side-menu'>
                    <div className='side-menu-button' style={{backgroundColor: selected === 'PENDING' ? 'var(--color-accent-bg)' : ''}} onClick={(e) => handleSideMenuButtonClick('PENDING')}>
                        <span className='name' style={{color: selected === 'PENDING' ? 'var(--color-main-white)' : ''}}>pending</span>
                        <span className='count' style={{border: findAnyUnSeenAvailable('PENDING') ? 'solid 0.2rem var(--color-main-red)' : 'none'}}>{dataCounter('PENDING')}</span>
                    </div>
                    <div className='side-menu-button' style={{backgroundColor: selected === 'ACCEPTED' ? 'var(--color-accent-bg)' : '', color: selected === 'PENDING' ? 'var(--color-text)' : ''}} onClick={(e) => handleSideMenuButtonClick('ACCEPTED')}>
                        <span className='name' style={{color: selected === 'ACCEPTED' ? 'var(--color-main-white)' : ''}}>approved</span>
                        <span className='count'>{dataCounter('ACCEPTED')}</span>
                    </div>
                    <div className='side-menu-button' style={{backgroundColor: selected === 'INITIATE' ? 'var(--color-accent-bg)' : '', color: selected === 'INITIATE' ? 'var(--color-text)' : ''}} onClick={(e) => handleSideMenuButtonClick('INITIATE')}>
                        <span className='name' style={{color: selected === 'INITIATE' ? 'var(--color-main-white)' : ''}}>created</span>
                        <span className='count'>{dataCounter('INITIATE')}</span>
                    </div>
                </div>
                <div className='email-body'>
                    {detailsSelected === '' ? (
                        <>
                            {selected === 'ACCEPTED' && (
                                <>
                                    {filterDataByType('ACCEPTED').length > 0 ? (
                                        <>
                                            <WarningTable data={[...filterDataByType('ACCEPTED')]} onRowClick={handleClickMessage}/> 
                                        </>
                                    ) : (
                                        <div className='empty-data-wrapper'>
                                            <span>---- No any approved requests available ----</span>
                                        </div>
                                    )}
                                </>
                            )}
                            {selected === 'PENDING' && (
                                <>
                                    {filterDataByType('PENDING').length > 0 ? (
                                        <WarningTable data={[...filterDataByType('PENDING')]} onRowClick={handleClickMessage}/> 
                                    ) : (
                                        <div className='empty-data-wrapper'>
                                            <span>---- No any pending requests available ----</span>
                                        </div>
                                    )}
                                </>
                            )}
                            {selected === 'REJECTED' && (
                                <>
                                  <WarningTable data={[...filterDataByType('REJECTED')]} onRowClick={handleClickMessage}/> 
                                </>
                            )}
                            {/* ADD: Add new category for see tiger warning by current user */}
                            {selected === 'INITIATE' && (
                                <>
                                    {filterDataByType('INITIATE').length > 0 ? (
                                        <WarningTable data={[...filterDataByType('INITIATE')]} onRowClick={handleClickMessage}/>
                                    ) : (
                                        <div className='empty-data-wrapper'>
                                            <span>---- No any created requests available ----</span>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        detailsSelected !== '' && detailsSelectedData !== undefined && (
                            
                        <WarningWorkflowProcess type='INTERNAL' id={detailsSelectedData.warningId} setAddRecipient={setAddRecipientStatus} checkedRecipient={selectedRecipient} catMType={detailsSelectedData.type}/>
                        )
                    )}
                </div>
            </div>
            {isLoading && (
                <LoadingScreen />
            )}
            
            {alertDialogState && (
                <AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertCallback}
                />
            )}
		</div>
    )
}

export default EarlyWarningMessages